"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchStateFilter = void 0;
var MatchStateFilter;
(function (MatchStateFilter) {
    /**
     * All tournament statuses
     */
    MatchStateFilter["All"] = "all";
    /**
     * Pending, Live matches
     */
    MatchStateFilter["Open"] = "open";
    /**
     * Canceled, Finished, Expired, Failed matches
     */
    MatchStateFilter["Past"] = "past";
})(MatchStateFilter = exports.MatchStateFilter || (exports.MatchStateFilter = {}));
//# sourceMappingURL=match-state-filter.js.map